module.exports = __webpack_public_path__ + "fonts/Barlow-Light.3b90170b.woff2";